import { useCallback, useState } from 'react';

import { adminLocalizationApi, adminLocalizationKeys } from '@/api';
import { ConstructorApi } from '@/features/constructor/api';
import { queryClient } from '@/app/QueryClientProvider';
import { usePopups } from '@/hooks';

export const useQuestionnaireAnswer = ({ questionnaireId }) => {
  const { showErrorToast, showSuccessToast } = usePopups();
  const [isCreating, setIsCreating] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleCreate = useCallback(async (answer, questionId) => {
    try {
      setIsCreating(true);
      const result = await ConstructorApi.createAnswer(answer, questionId);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getQuestionnaireSections],
          queryFn: () =>
            adminLocalizationApi.getQuestionnaireSections({
              questionSectionTypeId: questionnaireId
            })
        });
        showSuccessToast('Created');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsCreating(false);
    }
  }, []);

  const handleUpdate = useCallback(async (answer) => {
    try {
      setIsUpdating(true);
      const result = await ConstructorApi.updateAnswer(answer);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getQuestionnaireSections],
          queryFn: () =>
            adminLocalizationApi.getQuestionnaireSections({
              questionSectionTypeId: questionnaireId
            })
        });
        showSuccessToast('Saved');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsUpdating(false);
    }
  }, []);

  const handleDelete = useCallback(async (answer) => {
    try {
      setIsDeleting(true);
      const result = await ConstructorApi.deleteAnswer(answer);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getQuestionnaireSections],
          queryFn: () =>
            adminLocalizationApi.getQuestionnaireSections({
              questionSectionTypeId: questionnaireId
            })
        });
        showSuccessToast('Saved');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsDeleting(false);
    }
  }, []);

  return {
    handleCreate,
    handleUpdate,
    handleDelete,
    isCreating,
    isUpdating,
    isDeleting
  };
};
